import { render, staticRenderFns } from "./leaderCard.vue?vue&type=template&id=b33d7c9c&scoped=true"
import script from "./leaderCard.vue?vue&type=script&lang=js"
export * from "./leaderCard.vue?vue&type=script&lang=js"
import style0 from "./leaderCard.vue?vue&type=style&index=0&id=b33d7c9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33d7c9c",
  null
  
)

export default component.exports